// Sidebar + content shell for every /admin/* route.
// Sidebar collapses to a drawer on small screens (mobile top bar + hamburger).

import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AdminLayout.css';

const NAV = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/applications', label: 'Applications' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/stores', label: 'Stores' },
  { to: '/admin/merchants', label: 'Merchants' },
  { to: '/admin/moderation', label: 'Task moderation' },
  { to: '/admin/coupons', label: 'Coupons' },
  { to: '/admin/flyers', label: 'Flyers' },
  { to: '/admin/broadcast', label: 'Push broadcast' },
];

export default function AdminLayout() {
  const { user } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // Auto-close drawer on route change — touch users expect this.
  useEffect(() => { setDrawerOpen(false); }, [location.pathname]);

  // Lock background scroll while drawer is open on mobile.
  useEffect(() => {
    if (drawerOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  const activeLabel = NAV.find(n =>
    n.end ? location.pathname === n.to : location.pathname.startsWith(n.to)
  )?.label || 'Admin';

  return (
    <div className="portal-shell">
      <div className="portal-mobile-bar">
        <button
          type="button"
          className="portal-menu-toggle"
          aria-label="Open navigation"
          onClick={() => setDrawerOpen(true)}
        >☰</button>
        <span className="portal-mobile-title">{activeLabel}</span>
      </div>

      <div
        className={`portal-sidebar-backdrop${drawerOpen ? ' open' : ''}`}
        onClick={() => setDrawerOpen(false)}
      />

      <nav className={`portal-sidebar${drawerOpen ? ' open' : ''}`}>
        <div className="portal-sidebar-brand">
          TUDU Admin
          <small>{user?.email || user?.username}</small>
        </div>
        {NAV.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <main className="portal-content">
        <Outlet />
      </main>
    </div>
  );
}
